module.exports = __webpack_public_path__ + "img/7_128.e411d794.png";